import React from "react";

export default function GradientButton({
  iconSrc,
  altText,
  text,
  gradientColors,
  onClick,
}) {
  return (
    <div
      className={`inline-flex p-[2px] rounded-full bg-gradient-to-tr ${gradientColors}`}
    >
      <button
        onClick={onClick}
        className="flex items-center gap-2 px-3 sm:px-3 py-2 sm:py-2.5 rounded-full bg-white leading-none"
      >
        {iconSrc && (
          <img
            src={iconSrc}
            alt={altText || "icon"}
            className="w-3 h-3 sm:w-5 sm:h-5"
          />
        )}
        <span
          className={`bg-gradient-to-r ${gradientColors} text-transparent bg-clip-text font-medium text-xs xs:text-[10px] sm:text-xl `}
        >
          {text}
        </span>
      </button>
    </div>
  );
}
